import { render, staticRenderFns } from "./ClueDetail.vue?vue&type=template&id=30e8f88c&scoped=true"
import script from "./ClueDetail.vue?vue&type=script&lang=js"
export * from "./ClueDetail.vue?vue&type=script&lang=js"
import style0 from "./ClueDetail.vue?vue&type=style&index=0&id=30e8f88c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e8f88c",
  null
  
)

export default component.exports